<!--
File: fascicle-edit.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Tuesday, 10th March 2026 7:45:04 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<div class="fascicle-desk p-0 border-0">
  <!-- Se muestra si existen páginas -->
  <div
    class="wrap-fascicle flex flex-row justify-content-start"
    *ngIf="pages.length > 0"
  >
    <div class="flex flex-column border-0 w-10">
      <!-- Paginas y listado de productos -->
      <!-- <top-breadcrumbs></top-breadcrumbs> -->

      <div class="a4-wrapper p-2" id="fascicle_pages">
        <!-- 
      Esto va en el div de arriba fascicle_pages
      (wheel)="changePages($event)" 
      -->
        <div
          class="arrows hover-container full-space nav-arrow nav-arrow--left"
          [ngClass]="{
            'no-hover': gPage.index === 0,
            'disabled': !gridLocked.locked
          }"
          (click)="gPage.index > 0 && gridLocked.locked && navigatePrev()"
        >
          <p-button
            *ngIf="gPage.index > 0"
            icon="pi pi-angle-left"
            [styleClass]="'p-button-text custom-icon-button'"
            [pTooltip]="'FASCICLE.NAV.PREV_PAGE' | translate"
            tooltipPosition="right"
          ></p-button>
        </div>
        <div class="a4-container" [ngClass]="pageAnimClass">
          <p-progressBar mode="indeterminate" *ngIf="loading"></p-progressBar>
          <ng-container *ngFor="let pageIndex of currentPageIndex; index as i">
            <!-- Contenedor vacío por si no existe página -->
            <div
              class="a4-page"
              *ngIf="
                currentPageIndex.length < 2 && pageIsOdd(currentPageIndex[0])
              "
            >
              <img src="./assets/img/nube_cc_200x140.png" class="opacity-20" />
            </div>

            <div
              class="a4-page border-0"
              [ngClass]="
                gridLocked.index != pageIndex && !gridLocked.locked
                  ? 'disabled'
                  : ''
              "
            >
              <app-cc-grid
                *ngIf="pages[pageIndex]"
                [pageIndex]="pageIndex"
                [totalPages]="pages.length"
                [baseGrids]="allPageTemplates"
                [idCatalog]="idCatalog"
                [idFascicle]="idFascicle"
                [idPage]="pages[pageIndex].id"
                [isOdd]="pageIsOdd(pageIndex)"
                (isLocked)="checkLocked($event)"
              >
              </app-cc-grid>
            </div>
            <div
              class="a4-page"
              *ngIf="
                currentPageIndex.length < 2 && !pageIsOdd(currentPageIndex[0])
              "
            >
              <img src="./assets/img/nube_cc_200x140.png" class="opacity-20" />
            </div>
          </ng-container>
        </div>
        <div
          class="arrows hover-container full-space nav-arrow nav-arrow--right"
          [ngClass]="{
            'nav-arrow--add': gPage.index === gPage.pagination.length - 1,
            'disabled': !gridLocked.locked
          }"
          (click)="gPage.index === gPage.pagination.length - 1 ? addPage() : (gridLocked.locked && navigateNext())"
        >
          <p-button
            *ngIf="gPage.index < gPage.pagination.length - 1"
            icon="pi pi-angle-right"
            [styleClass]="'p-button-text custom-icon-button'"
            [pTooltip]="'FASCICLE.NAV.NEXT_PAGE' | translate"
            tooltipPosition="left"
          ></p-button>
          <p-button
            *ngIf="gPage.index === gPage.pagination.length - 1"
            icon="pi pi-plus"
            [styleClass]="'p-button-text custom-icon-button'"
            severity="success"
            [pTooltip]="'FASCICLE.NAV.ADD_PAGE' | translate"
            tooltipPosition="left"
          ></p-button>
        </div>
      </div>
      <p-progressBar
        [value]="(gPage.index / (gPage.pagination.length - 1)) * 100"
        [showValue]="false"
        [mode]="'determinate'"
        [style]="{ width: '100%', height: '2px' }"
      >
      </p-progressBar>
      <!-- Paginador -->
      <app-fascicle-paginator
        [currentComboPageIndex]="currentComboPageIndex"
        [currentNumberPages]="currentNumberPages"
        [gPage]="gPage"
        [pages]="pages"
        (onNavigate)="handlePaginatorNavigate($event)"
      ></app-fascicle-paginator>
    </div>

    <div class="w-2 z-5 fascicle-product-toolbar">
      <app-product-toolbar
        [idCatalog]="idCatalog"
        [idFascicle]="idFascicle"
        [filter]="productFilter"
        (showHistory)="historyPanelVisible = true"
      ></app-product-toolbar>
    </div>
  </div>

  <!-- Panel lateral de historial -->
  <p-sidebar
    [(visible)]="historyPanelVisible"
    position="right"
    styleClass="w-22rem"
  >
    <ng-template pTemplate="header">
      <span class="font-semibold text-lg">{{
        "FASCICLE.HISTORY" | translate
      }}</span>
    </ng-template>
    <app-fascicle-history-panel
      [idCatalog]="idCatalog"
      [idFascicle]="idFascicle"
    />
  </p-sidebar>

  <!-- Se muestra si no existen páginas  -->
  <div
    class="flex p-1 justify-content-center align-items-center"
    *ngIf="pages.length == 0"
  >
    <p-card class="p-2">
      <ng-template pTemplate="header">
        <span class="text-xl p-2">{{ "FASCICLE.NO_PAGES" | translate }}</span>
      </ng-template>
      <ng-template pTemplate="footer">
        <p-button
          color="primary"
          (onClick)="addTheFirstPage()"
          label="{{ 'FASCICLE.CREATE_PAGE' | translate }}"
          icon="pi pi-plus"
        />
      </ng-template>
    </p-card>
  </div>
</div>
